import { IProject } from "@kuika/kuika-cl-model";
import _ from "lodash";

/**
 * Designer-live project refresh (project.changed / workflowScreens.changed) support.
 *
 * A freshly fetched project is NOT state-shape-complete: convertProjectDTOToInterface
 * only carries the component-set id shell, while the loaded component definitions
 * (ComponentSetService) and the injected default language are client-side enrichments
 * applied once by loadProject. Swapping a raw fetch into state strips
 * project.componentSetObj.components and crashes every properties-panel render
 * ("Cannot read properties of undefined (reading 'find')" → white screen).
 */

/**
 * A remote-triggered refresh may only replace state.project once the open project
 * has been fully enriched. Before that, the in-flight open fetches fresh data anyway.
 */
export function isProjectRefreshSafe(current: IProject | undefined): boolean {
  if (!current || _.isEmpty(current)) return false;
  return !_.isEmpty(current.componentSetObj?.components);
}

/**
 * Carries the client-side enrichments of the currently open project onto a freshly
 * fetched one, in place: the loaded component set always (the DTO never has it), and
 * the languages list only when the fresh project came back empty (loadProject injects
 * a default en_US into legacy projects — the server copy stays empty).
 */
export function graftClientProjectEnrichments(fresh: IProject, current: IProject): void {
  fresh.componentSetObj = current.componentSetObj;
  if (_.isEmpty(fresh.languages) && !_.isEmpty(current.languages)) {
    fresh.languages = current.languages;
  }
}
